import { useEffect } from 'react'
import { Navigate, Routes } from 'react-router-dom'
import { useAuth } from './core/Auth'

export function Logout() {
    const { logout } = useAuth()
    useEffect(() => {
        logout()
            .then(() => {
                document.location.reload()
            })
            .catch((error) => {
                console.error('Error during logout:', error)
                // Still reload even if logout API fails
                document.location.reload()
            })
    }, [logout])

    return (
        <Routes>
            <Navigate to='/auth/login' />
        </Routes>
    )
}
